import {createSelector} from 'reselect';

const isLoggedInSelector = createSelector(
    (state) => state.me,
    (me) => (me != null)
);

const getAllPropsSelector = (state) => {
    return {
        me: (state.me) ? state.me : null,
        isLoggedIn: isLoggedInSelector(state),
        loading: state.ajaxCallsInProgress > 0,
        currentDate: state.currentDate
    };
};

export default getAllPropsSelector;

export {
    getAllPropsSelector
};


/** WEBPACK FOOTER **
 ** ./src/container/App/selectors.js
 **/